/* eslint-disable */
function newOriginPoint() {
    return {
        x: 0,
        y: 0,
    };
}

function distance(p1, p2) {
    // Pythagorean Theorem: c^2 = a^2 + b^2
    const { x: x1, y: y1 } = p1;
    const { x: x2, y: y2 } = p2;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
}

function midpoint(p1, p2) {
    return {
        x: (p1.x + p2.x) / 2,
        y: (p1.y + p2.y) / 2,
    };
}

function offset(p, origin) {
    return {
        x: p.x - origin.x,
        y: p.y - origin.y,
    };
}

function map(p, f) {
    return {
        x: f(p.x),
        y: f(p.y),
    };
}

function scale(p, s) {
    return map(p, v => v * s);
}

function sum(p1, p2) {
    return {
        x: p1.x + p2.x,
        y: p1.y + p2.y,
    };
}

function isEqual(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}

function boundWithin(min, current, max) {
    const numberWithin = (lower, num, upper) => (num > upper ? upper : lower > num ? lower : num);
    return {
        x: numberWithin(min.x, current.x, max.x),
        y: numberWithin(min.y, current.y, max.y),
    };
}

function normalizePointInRect(point, rect) {
    return {
        x: point.x - rect.origin.x,
        y: point.y - rect.origin.y,
    };
}

function toSize(p) {
    return {
        width: p.x,
        height: p.y,
    };
}

export const Point = {
    newOriginPoint,
    distance,
    midpoint,
    offset,
    sum,
    map,
    scale,
    isEqual,
    boundWithin,
    toSize,
};
